import xhr from 'Common/utils/xhr'
import { foldersEndpoint } from './endpoints'

const deleteFolder = id =>
  xhr({
    url: `${foldersEndpoint}/${id}`,
    method: 'DELETE',
  })

export default deleteFolder
